import { Card } from "semantic-ui-react";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { NewListPageComponent } from "../components/page/NewListPageComponent";
import { getSession } from "../helper";
import {
  CREATE_PHYSICAL_LIBRARY_LOCATION,
  DELETE_PHYSICAL_LIBRARY_LOCATION,
  UPDATE_PHYSICAL_LIBRARY_LOCATION,
} from "../routes/mutations";
import { LIST_PHYSICAL_LIBRARY_LOCATIONS } from "../routes/queries";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { getPhysicalLibraryLocationForm } from "./physical_library_location_form";

const PhysicalLibraryLocationCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "new_form_modal",
                  label: "Edit",
                  modalHeader: "Edit Physical Library Location",
                  apiCall: {
                    documentNode: UPDATE_PHYSICAL_LIBRARY_LOCATION,
                    key: "updatePhysicalLibraryLocation",
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  callback: (data: any) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: getPhysicalLibraryLocationForm(),
                    startingData: {
                      name: props.data.name,
                      id: props.data.id,
                    },
                  }),
                },
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: {
                    documentNode: DELETE_PHYSICAL_LIBRARY_LOCATION,
                    key: "deletePhysicalLibraryLocation",
                  },
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      deletionStrategy: "orphan_reference_library_elements",
                    };
                  },
                  showMenuOption: (data: any) => {
                    return data.referenceLibraryElements.length === 0;
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  apiCall: {
                    documentNode: DELETE_PHYSICAL_LIBRARY_LOCATION,
                    key: "deletePhysicalLibraryLocation",
                  },
                  showMenuOption: (data: any) => {
                    return data.referenceLibraryElements.length > 0;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: [
                        {
                          type: "radio_button",
                          key: "deletionStrategy",
                          label:
                            "When deleting this physical library location, what should be done with its reference library elements?",
                          options: [
                            {
                              value: "delete_reference_library_elements",
                              label: "Delete all reference library elements",
                            },
                            {
                              value: "orphan_reference_library_elements",
                              label:
                                "Keep all reference library elements (they will no longer be associated with a physical library location)",
                            },
                          ],
                        },
                        {
                          type: "hardcoded",
                          value: getSession(),
                          key: "session",
                        },
                        {
                          type: "hardcoded",
                          value: props.data.id,
                          key: "id",
                        },
                      ],
                      type: "single_form",
                    },
                    startingData: {
                      deletionStrategy: "delete_reference_library_elements",
                      id: props.data.id,
                      session: getSession(),
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content className="reference-library-elements">
        <b>Reference Library Elements</b>
        {props.data.referenceLibraryElements.map((element: any) => {
          return (
            <div key={element.id} className="reference-library-element">
              {element.name}
            </div>
          );
        })}
      </Card.Content>
    </Card>
  );
};

export const NewPhysicalLibraryLocationsPage = () => {
  return (
    <NewListPageComponent
      props={{
        type: "list_page",
        query: {
          documentNode: LIST_PHYSICAL_LIBRARY_LOCATIONS,
          key: "listPhysicalLibraryLocations",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Physical Library Location",
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: getPhysicalLibraryLocationForm(),
            startingData: {
              name: "",
            },
          }),
          apiCall: {
            documentNode: CREATE_PHYSICAL_LIBRARY_LOCATION,
            key: "createPhysicalLibraryLocation",
          },
        },
        card: PhysicalLibraryLocationCard,
      }}
    />
  );
};
